/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        this.initializeCollectionTabs();
      }, 100);
    }

    initializeCollectionTabs() {
      // Find the collection tabs buttons within this element
      const buttons = Array.from(this.querySelectorAll('.collection-tabs__list-link'));
      if (!buttons.length) {
        console.log('CollectionTabs: No buttons found');
        return;
      }
      
      const sectionHeader = this.closest('.section-header');
      if (!sectionHeader) {
        console.log('CollectionTabs: No section header found');
        return;
      }
      
      const links = sectionHeader.querySelectorAll('.linked-to-tab');
      this.target = this.dataset.target;
      this.themeScroll = sectionHeader.nextElementSibling;
      
      console.log('CollectionTabs: Initialized with', buttons.length, 'buttons');
      
      // Handle tab navigation
      buttons.forEach((button, i) => {
        button.addEventListener('click', (event) => {
          this.toggleButtons(buttons, i);
          this.toggleLinks(links, i);
          if (button.dataset.collection) {
            this.toggleCollection(button.dataset.collection);
          }
          event.preventDefault();
        });
      });

      // Setup basic carousel navigation
      this.setupCarouselNavigation();

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const index = buttons.indexOf(event.target);
          if (index !== -1) {
            buttons[index].dispatchEvent(new Event('click'));
          }
        });
      }
    }

    setupCarouselNavigation() {
      // Find navigation elements in the parent section, not just this element
      const section = this.closest('.collection-tabs');
      if (!section) {
        console.log('CollectionTabs: No collection-tabs section found');
        return;
      }
      
      const prevButton = section.querySelector('.flickity-prev');
      const nextButton = section.querySelector('.flickity-next');
      const carousel = section.querySelector('.products.carousel');
      
      console.log('CollectionTabs: Looking for navigation elements...');
      console.log('Section:', section);
      console.log('Prev button:', prevButton);
      console.log('Next button:', nextButton);
      console.log('Carousel:', carousel);
      
      if (!prevButton || !nextButton || !carousel) {
        console.log('CollectionTabs: Navigation elements not found');
        // Try alternative selectors
        const altPrevButton = section.querySelector('button[name="prev"]');
        const altNextButton = section.querySelector('button[name="next"]');
        console.log('Alternative prev button:', altPrevButton);
        console.log('Alternative next button:', altNextButton);
        return;
      }

      console.log('CollectionTabs: Setting up carousel navigation');

      // Calculate scroll amount (one product width + gap)
      const getScrollAmount = () => {
        const firstProduct = carousel.querySelector('.collection-tabs--product');
        if (!firstProduct) return 300;
        
        const productWidth = firstProduct.offsetWidth;
        const computedStyle = window.getComputedStyle(carousel);
        const gap = parseInt(computedStyle.gap) || 27;
        return productWidth + gap;
      };

      // Previous button
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('CollectionTabs: Previous button clicked');
        const scrollAmount = getScrollAmount();
        carousel.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
        this.updateArrowStates();
      });

      // Next button
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('CollectionTabs: Next button clicked');
        const scrollAmount = getScrollAmount();
        carousel.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
        this.updateArrowStates();
      });

      // Update arrow states based on scroll position
      this.updateArrowStates = () => {
        const isAtStart = carousel.scrollLeft <= 0;
        const isAtEnd = carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth;
        
        prevButton.disabled = isAtStart;
        nextButton.disabled = isAtEnd;
        
        console.log('CollectionTabs: Arrow states updated - Start:', isAtStart, 'End:', isAtEnd);
      };

      // Initial state
      this.updateArrowStates();
      
      // Update on scroll
      carousel.addEventListener('scroll', () => {
        this.updateArrowStates();
      });
      
      // Update on resize
      window.addEventListener('resize', () => {
        this.updateArrowStates();
      });
    }

    toggleButtons(buttons, index) {
      buttons.forEach((button) => button.classList.remove('active'));
      buttons[index].classList.add('active');
    }

    toggleLinks(links, index) {
      if (links.length) {
        links.forEach((link) => link.classList.remove('active'));
        links[index].classList.add('active');
      }
    }

    toggleCollection(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return;
      
      const products = slider.querySelectorAll(`.collection-tabs--product:not([data-collection="${handle}"])`);
      const activeProducts = slider.querySelectorAll(`[data-collection="${handle}"]`);

      products.forEach((product) => product.classList.remove('carousel__slide'));
      activeProducts.forEach((product) => product.classList.add('carousel__slide'));

      // Reset scroll position
      const carousel = slider.closest('.products.carousel');
      if (carousel) {
        carousel.scroll({
          top: 0,
          left: 0
        });
      }
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}